// extracted by mini-css-extract-plugin
module.exports = {"ProductList":"ProductList_ProductList__0pldX","DutyFreeModal":"ProductList_DutyFreeModal__Hj7Hi"};